import { render, staticRenderFns } from "./SegmentedTabs.vue?vue&type=template&id=74318610&scoped=true&"
import script from "./SegmentedTabs.vue?vue&type=script&lang=js&"
export * from "./SegmentedTabs.vue?vue&type=script&lang=js&"
import style0 from "./SegmentedTabs.vue?vue&type=style&index=0&id=74318610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74318610",
  null
  
)

export default component.exports